export const createResearchSchedule = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-schedules/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create presentation schedule: ");
    }
    return response.json();
};

export const getResearchSchedules = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-schedules/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const getResearchSchedule = async (bearer: string, id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-schedules/${id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const updateResearchSchedule = async (
    bearer: String,
    id: String,
    data: FormData
) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/research-schedules/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        throw new Error("Failed to update research schedule");
    }
    return response.json();
};

